import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_baseLayout/')({
  component: () => <Navigate to='/inbox' />,
});
